import { render, staticRenderFns } from "./BulkResultTabBody.vue?vue&type=template&id=87f8e560"
import script from "./BulkResultTabBody.vue?vue&type=script&lang=js"
export * from "./BulkResultTabBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports